import React from 'react';
import styled from 'styled-components';

const TimezoneParagraph = styled.p`
  margin-bottom: 10px;
`;

const TimezoneContainer = styled.div``;

const TimezoneExplainer = ({
  style,
}) => (
  <TimezoneContainer style={style}>
    <TimezoneParagraph>
      The deadline date and time will be displayed in users' local timezones.
    </TimezoneParagraph>
  </TimezoneContainer>
);

export default TimezoneExplainer;
